require('./brokerProductFileTab.scss');

const PropTypes = require('prop-types');

const React = require('react');
const { Component } = require('react');
const { getLanguage } = require('core/i18n').i18n;

class TechnicalAnalysisTab extends Component {
    render() {
        const { isinCode, micCode } = this.props;
        const language = getLanguage() === 'es' ? 'es' : getLanguage();
        const iframeUrl = `https://openbank-analisis.webfg.com/analisis/${micCode}/${isinCode}/${language}`;

        return (
            <div className="broker-product-file-tab">
                <iframe
                    className="broker-product-file-tab__iframe"
                    src={iframeUrl} />
            </div>
        );
    }
}

TechnicalAnalysisTab.propTypes = {
    isinCode: PropTypes.string,
    micCode: PropTypes.string
}

module.exports = TechnicalAnalysisTab;
